import { Injectable } from "@angular/core";

import { Exception } from "../store/shared/http-request-state";

import { ExceptionName } from "./backend/shared/exceptions/exception.model";

@Injectable({
  providedIn: "root",
})
export class PermissionService {
  hasApplicationExpired(error?: Exception | null) {
    return error?.name === ExceptionName.ACCESS_TO_APPLICATION_HAS_EXPIRED;
  }
}
